import Joi from 'joi';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestConferenceEndSchema } from '../../requests/communications-request-conference-end/communications-request-conference-end-schema';
import { CommunicationsRequestConferenceParticipantCreateSchema } from '../../requests/communications-request-conference-participant-create/communications-request-conference-participant-create-schema';
import { CommunicationsRequestConferenceParticipantUpdateSchema } from '../../requests/communications-request-conference-participant-update/communications-request-conference-participant-update-schema';
import { CommunicationsRequestCreateAsyncServiceRequestSchema } from '../../requests/communications-request-create-async-service-request/communications-request-create-async-service-request-schema';
import { CommunicationsRequestCreateOutboundCallSessionSchema } from '../../requests/communications-request-create-outbound-call-session/communications-request-create-outbound-call-session-schema';
import { CommunicationsRequestDialAsyncServiceRequestSchema } from '../../requests/communications-request-dial-async-service-request/communications-request-dial-async-service-request-schema';
import { CommunicationsRequestDialConferenceSchema } from '../../requests/communications-request-dial-conference/communications-request-dial-conference-schema';
import { CommunicationsRequestDialPhoneSchema } from '../../requests/communications-request-dial-phone/communications-request-dial-phone-schema';
import { CommunicationsRequestGetCallLogPIISchema } from '../../requests/communications-request-get-call-log-pii/communications-request-get-call-log-pii-schema';
import { CommunicationsRequestGetConferenceParticipantsSchema } from '../../requests/communications-request-get-conference-participants/communications-request-get-conference-participants-schema';
import { CommunicationsRequestGetConversationLogPIISchema } from '../../requests/communications-request-get-conversation-log-pii/communications-request-get-conversation-log-pii-schema';
import { CommunicationsRequestGetSessionIdSchema } from '../../requests/communications-request-get-session-id/communications-request-get-session-id-schema';
import { CommunicationsRequestGetVoiceDeviceTokenSchema } from '../../requests/communications-request-get-voice-device-token/communications-request-get-voice-device-token-schema';
import { CommunicationsRequestHandleAsyncServiceRequestSchema } from '../../requests/communications-request-handle-async-service-request/communications-request-handle-async-service-request-schema';
import { CommunicationsRequestOnTaskRouterConfigurationUpdatedSchema } from '../../requests/communications-request-on-task-router-configuration-updated/communications-request-on-task-router-configuration-updated-schema';
import { CommunicationsRequestOnVrcAudioUpdateSchema } from '../../requests/communications-request-on-vrc-audio-update/communications-request-on-vrc-audio-update-schema';

export class AnyCommunicationsRequestSchema extends SerializableObjectSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // The type of the entity
  public static readonly type = 'type';

  private static readonly SCHEMA_ID = 'anyCommunicationsRequest';

  private static computedSchema = Joi.alternatives()
    .try(
      ...[
        new CommunicationsRequestConferenceEndSchema().getJoiSchema(),
        new CommunicationsRequestConferenceParticipantCreateSchema().getJoiSchema(),
        new CommunicationsRequestConferenceParticipantUpdateSchema().getJoiSchema(),
        new CommunicationsRequestCreateAsyncServiceRequestSchema().getJoiSchema(),
        new CommunicationsRequestCreateOutboundCallSessionSchema().getJoiSchema(),
        new CommunicationsRequestDialAsyncServiceRequestSchema().getJoiSchema(),
        new CommunicationsRequestDialConferenceSchema().getJoiSchema(),
        new CommunicationsRequestDialPhoneSchema().getJoiSchema(),
        new CommunicationsRequestGetCallLogPIISchema().getJoiSchema(),
        new CommunicationsRequestGetConferenceParticipantsSchema().getJoiSchema(),
        new CommunicationsRequestGetConversationLogPIISchema().getJoiSchema(),
        new CommunicationsRequestGetSessionIdSchema().getJoiSchema(),
        new CommunicationsRequestGetVoiceDeviceTokenSchema().getJoiSchema(),
        new CommunicationsRequestHandleAsyncServiceRequestSchema().getJoiSchema(),
        new CommunicationsRequestOnTaskRouterConfigurationUpdatedSchema().getJoiSchema(),
        new CommunicationsRequestOnVrcAudioUpdateSchema().getJoiSchema(),
      ],
    )
    .id(AnyCommunicationsRequestSchema.SCHEMA_ID);

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static GenericDefaults = class {
    // The name of the command
    public static readonly type = undefined;
  };

  /**
   * Always serialize the command name
   */
  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  public static getSchemaId(): string {
    return `#${AnyCommunicationsRequestSchema.SCHEMA_ID}`;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } | import('joi').AnySchema {
    return AnyCommunicationsRequestSchema.computedSchema;
  }
}
